import {
  FILTER_FINANCIAL_PRESS_RELEASE_KEY,
  searchFinancialPressRelease,
} from '../actions/financial-press-release';
import {
  FILTER_FINANCIAL_PUBLICATION_KEY,
  searchFinancialPublication,
} from '../actions/financial-publication';
import { FILTER_HOME_KEY, searchHome } from '../actions/home';
import {
  FILTER_HUB_ACTUS_KEY,
  searchHubActualites,
} from '../actions/hub-actualites';
import {
  FILTER_HUB_NEWSROOM_KEY,
  searchHubNewsroom,
} from '../actions/hub-newsroom';
import { FILTER_NEWSROOM_KEY, searchNewsroom } from '../actions/newsroom';
import { FILTER_GLOBAL_SEARCH_KEY, searchGlobal } from '../actions/search-page';

export const mappedSearch: Record<string, any> = {
  [FILTER_GLOBAL_SEARCH_KEY]: searchGlobal,
  [FILTER_HOME_KEY]: searchHome,
  [FILTER_HUB_ACTUS_KEY]: searchHubActualites,
  [FILTER_HUB_NEWSROOM_KEY]: searchHubNewsroom,
  [FILTER_NEWSROOM_KEY]: searchNewsroom,
  [FILTER_FINANCIAL_PRESS_RELEASE_KEY]: searchFinancialPressRelease,
  [FILTER_FINANCIAL_PUBLICATION_KEY]: searchFinancialPublication,
};
